(() => {
  function completeQuantities(root) {
    root.querySelectorAll('select[data-lotr-quantity-max]').forEach(select => {
      const maximum = Number(select.dataset.lotrQuantityMax);
      if (select.disabled || !Number.isSafeInteger(maximum) || maximum < 1) return;
      const next = Number(select.options[select.options.length - 1]?.value || 0) + 1;
      const options = document.createDocumentFragment();
      for (let quantity = next; quantity <= maximum; quantity++) {
        options.append(new Option(String(quantity), String(quantity)));
      }
      select.append(options);
    });
  }
  completeQuantities(document);
  document.addEventListener('shopify:section:load', event => completeQuantities(event.target));
})();
